import { render, staticRenderFns } from "./KioskPublic.vue?vue&type=template&id=56216c11&scoped=true"
import script from "./KioskPublic.vue?vue&type=script&lang=js"
export * from "./KioskPublic.vue?vue&type=script&lang=js"
import style0 from "./KioskPublic.vue?vue&type=style&index=0&id=56216c11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56216c11",
  null
  
)

export default component.exports